import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DeleteReasonPageRoutingModule } from './delete-reason-routing.module';

import { DeleteReasonPage } from './delete-reason.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, DeleteReasonPageRoutingModule, TranslateModule.forChild()],
  declarations: [DeleteReasonPage]
})
export class DeleteReasonPageModule {}
